import { render, staticRenderFns } from "./angrybird.vue?vue&type=template&id=60fe7b9b"
import script from "./angrybird.vue?vue&type=script&lang=js"
export * from "./angrybird.vue?vue&type=script&lang=js"
import style0 from "./angrybird.vue?vue&type=style&index=0&id=60fe7b9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports